module.exports = __webpack_public_path__ + "static/img/noheader_pic.88012fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noheader_pic.jpg
// module id = /s4o
// module chunks = 29